import { render, staticRenderFns } from "./ThresholdFormDrawer.vue?vue&type=template&id=ec4b4e24"
import script from "./ThresholdFormDrawer.vue?vue&type=script&lang=js"
export * from "./ThresholdFormDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports